import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { MessageAttachment } from './types'
import { Button } from '@/Atomic/Molecules/Button'
import { Modal } from '@/Atomic/Organisms/Modal'
import { DataImage } from '@/Components/DataImage'
import { DownloadAnchor } from '@/Components/shared/DownloadAnchor'
import { dataBinaryToUrl } from '@/utils/dataBinaryToUrl'

export interface MessageAttachmentImageModalProps {
  messageAttachment?: MessageAttachment
  isOpen: boolean
  close: () => void
}

export const MessageAttachmentImageModal: React.FC<
  MessageAttachmentImageModalProps
> = ({ messageAttachment, isOpen, close }) => {
  const { t } = useTranslation()
  const isImg = messageAttachment?.contentType.includes('image')
  const [downloadURL, setDownloadURL] = useState('')

  useEffect(() => {
    if (!messageAttachment) return
    dataBinaryToUrl(messageAttachment).then((e) => setDownloadURL(e.url))
  }, [messageAttachment])

  if (!messageAttachment || !isImg) return

  const fileName = messageAttachment.filename || 'File'
  const fileSize = `${Math.ceil(messageAttachment.contentLength / 1024)} KB`

  return (
    <Modal
      className="message-attachment-image-modal"
      isOpen={isOpen}
      onClose={close}
    >
      <Modal.Header>
        <h3>{fileName}</h3>
        <p className="mb-0">{fileSize}</p>
      </Modal.Header>
      <Modal.Body>
        <DataImage dataBinary={messageAttachment} defaultImage="" />
      </Modal.Body>
      <Modal.Footer>
        <div className="message-attachment-image-modal__footer">
          <Button variant="outlined" onClick={close}>
            {t('common.close')}
          </Button>
          <DownloadAnchor url={downloadURL} name={messageAttachment.filename}>
            <Button>{t('common.downloadFile')}</Button>
          </DownloadAnchor>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
